import { Header } from './sections/Header';
import { Hero } from './sections/Hero';
import CompatibleWithMajorSuppliers from './sections/CompatibleWithMajorSuppliers';
import WeUnderstandYourPain from './sections/WeUnderstandYourPain';
import OptimizeOperations from './sections/OptimizeOperations';
import RealResultsFromRealRestaurants from './sections/RealResultsFromRealRestaurants';
import ChooseSuitablePlan from './sections/ChooseSuitablePlan';
import CTABanner from './sections/CTABanner';
import Footer from './sections/Footer';
import { useAuth } from '../../../services/authentication/authContext';
import { Navigate } from 'react-router-dom';
import CompatibleWithMajorSuppliersMobile from './sections/CompatibleWithMajorSuppliersMobile';
import { useSubscription } from '../../../hooks/useSubscription';


const hiddenScrollbarStyle: React.CSSProperties = {
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE and Edge
    overflowY: "scroll",
};
const hiddenScrollbarInnerStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
};
 
const LandingPage: React.FC = () => {
    const { user } = useAuth();
    const { isActive } = useSubscription();
    if (user && isActive) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div
            style={hiddenScrollbarStyle as React.CSSProperties}
            className="hide-scrollbar light-mode-only"
        >
            <style>
                {`
                .hide-scrollbar::-webkit-scrollbar {
                    display: none;
                }
                /* Force light mode for landing page */
                .light-mode-only,
                .light-mode-only * {
                    color-scheme: light;
                }
                `}
            </style>
            <div style={hiddenScrollbarInnerStyle} className="!bg-white !text-gray-900">
                <Header />
                <Hero />
                <div className="hidden min-[1050px]:block"><CompatibleWithMajorSuppliers/></div>
                <div className="block min-[1050px]:hidden"><CompatibleWithMajorSuppliersMobile/></div>
                <WeUnderstandYourPain/>
                <OptimizeOperations/>
                <RealResultsFromRealRestaurants/>
                <ChooseSuitablePlan />
                <CTABanner />
                <Footer/>
            </div>
        </div>
    );
};

export default LandingPage;